<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import Window from "../components/Window.svelte";
  import type { WinCbs, WinProps } from "../scripts/WinTypes";
  import { addLog } from "../stores/LoggerStore";

  export let winProps: WinProps;
  const callbacks: WinCbs = {
    onFocus: () => {
      addLog("Markdown focus callback");
      textAreaElem.focus();
      return true;
    },
  };
  winProps.name = `Markdown${winProps.name ? " - " + winProps.name : ""}`;
  let textAreaElem,
    textAreaValue = winProps.data?.text || "";
  onMount(() => {});
  onDestroy(() => {});
</script>

<Window {winProps} {callbacks}>
  <div class="container">
    <textarea
      class="text-area"
      bind:this={textAreaElem}
      bind:value={textAreaValue}
    />
    <div class="md-viewer">
      {textAreaValue}
    </div>
  </div>
</Window>

<style>
  .container {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .text-area {
    flex: 1;
    margin: 0;
    padding: 0;
    resize: none;
    border: none;
    border-radius: 0;
  }
  .text-area:visible,
  .text-area:focus-visible {
    outline: none;
  }
  .md-viewer {
    border-left: 1px solid #333;
    flex: 1;
    background-color: white;
    color: #333;
    /* background-color: red; */
  }
</style>
